module.exports = __webpack_public_path__ + "static/OG_Insights-44412f5e2a44cf1f931faeeccec90db3.png";